import React from 'react';

let direction = 'ltr';

export const dezThemeSet = [
	{ /* Default */
		typography: "poppins",
		version: "light",
		layout: "vertical",
		headerBg: "color_1",
		navheaderBg: "color_1",
		sidebarBg: "color_1",
		sidebarStyle: "full",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "full",
		direction: direction
	},
	{ /* Demo Theme 1 */
		typography: "poppins",
		version: "light",
		layout: "vertical",
		navheaderBg: "color_1",
		headerBg: "color_5",
		sidebarStyle: "mini",
		sidebarBg: "color_1",
		sidebarPosition: "static",
		headerPosition: "fixed",
		containerLayout: "wide",
		primary: "color_5",
		direction: direction
	},
	 { /* Demo Theme 2 */
		typography: "poppins",
		version: "dark",
		layout: "vertical",
		navheaderBg: "color_8",
		headerBg: "color_1",
		sidebarStyle: "full",
		sidebarBg: "color_8",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "wide",
		primary: "color_14",
		direction: direction
	},
	{
		/* Demo Theme 3 */
		typography: "poppins",
		version: "light",
		layout: "vertical",
		navheaderBg: "color_2",
		headerBg: "color_1",
		sidebarStyle: "full",
		sidebarBg: "color_2",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "wide",
		primary: "color_2",
		direction: direction
	},
	{
		/* Demo Theme 4 */	
		typography: "poppins",
		version: "dark",
		layout: "vertical",
		navheaderBg: "color_7",
		headerBg: "color_1",
		sidebarStyle: "compact",
		sidebarBg: "color_7",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "wide",
		primary: "color_7",
		direction: direction
		
	},
	{
		/* Demo Theme 5 */
		typography: "poppins",
		version: "light",
		layout: "vertical",
		navheaderBg: "color_4",
		headerBg: "color_1",
		sidebarStyle: "icon-hover",
		sidebarBg: "color_4",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "wide",
		primary: "color_4",
		direction: direction
	},
	{
		/* Demo Theme 6 */
		typography: "poppins",
		version: "light",
		layout: "vertical",
		navheaderBg: "color_3",
		headerBg: "color_1",
		sidebarStyle: "mini",
		sidebarBg: "color_1",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "wide",
		primary: "color_1",
		direction: direction
	},
	{
		/* Demo Theme 7 */
		typography: "poppins",
		version: "light",
		layout: "vertical",
		navheaderBg: "color_2",
		headerBg: "color_1",
		sidebarStyle: "mini",
		sidebarBg: "color_2",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "wide",
		primary: "color_2",
		direction: direction
	},
	{
		/* Demo Theme 8 */
		typography: "poppins",
		version: "light",
		layout: "vertical",
		navheaderBg: "color_14",
		headerBg: "color_14",
		sidebarStyle: "full",
		sidebarBg: "color_2",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "wide",
		primary: "color_2",
		direction: direction
	}
];
	